
export const AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID = process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;
export const AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI = process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI